module.exports = __webpack_public_path__ + "img/number.eff8cf98.svg";